
import React from "react";
import {
  FiArrowRight,
  FiTrendingUp,
  FiShield,
  FiTruck,
  FiLock,
  FiPackage,
  FiHeadphones,
  FiAward,
  FiHeart,
} from "react-icons/fi";

import WellnessImage from "../../assets/img/WellnessImage.png";
import LingerieImage from "../../assets/img/LingerieImage.png";
import CannabisImage from "../../assets/img/CannabisImage.png";

const collections = [
  {
    title: "The Wellness Edit",
    description: "Relax. Rebalance. Feel Your Best.",
    button: "Shop Wellness",
    href: "/wellness",
    image: WellnessImage,
  },
  {
    title: "Lingerie Looks",
    description: "Confidence in Every Detail.",
    button: "Shop Lingerie",
    href: "/lingerie",
    image: LingerieImage,
  },
  {
    title: "The Cannabis Collection",
    description: "Premium Flower, Edibles & More.",
    button: "Shop Cannabis",
    href: "/cannabis-hemp",
    image: CannabisImage,
  },
];

const sellerBenefits = [
  {
    title: "Grow Your Brand",
    description: "Reach a passionate audience",
    icon: FiTrendingUp,
  },
  {
    title: "Zero Upfront Fees",
    description: "Simple, transparent pricing",
    icon: FiShield,
  },
  {
    title: "Dedicated Support",
    description: "We're here to help you succeed",
    icon: FiHeadphones,
  },
];

const shoppingBenefits = [
  {
    title: "Premium & Trusted Brands",
    description: "Carefully curated marketplace",
    icon: FiAward,
  },
  {
    title: "Discreet Shipping",
    description: "Your privacy is our priority",
    icon: FiTruck,
  },
  {
    title: "Secure Payments",
    description: "Shop with confidence",
    icon: FiLock,
  },
  {
    title: "Wide Selection",
    description: "Top brands & unique products",
    icon: FiPackage,
  },
  {
    title: "Dedicated Support",
    description: "Real people, real help",
    icon: FiHeadphones,
  },
];

function SectionHeading({ children }) {
  return (
    <h2 className="flex items-center gap-2 font-serif text-[20px] font-bold leading-tight tracking-[-0.45px] text-[#211c26] sm:text-[22px]">
      <span className="h-[19px] w-[3px] shrink-0 rounded-full bg-[#7027df]" />
      {children}
    </h2>
  );
}

export default function CuratedCollections() {
  return (
    <section className="w-full overflow-hidden bg-[#fffdfb] font-sans text-[#211c26]">
      <div className="mx-auto w-full max-w-[1500px]">

        {/* Curated Collections */}
        <div className="px-4 py-5 sm:px-6 sm:py-6 lg:px-[4%]">
          <div className="mb-4 flex items-center justify-between gap-4">
            <SectionHeading>Curated Collections</SectionHeading>

            <a
              href="/collections"
              className="inline-flex shrink-0 items-center gap-1.5 text-[12px] font-semibold text-[#7027df] transition-colors hover:text-[#4818a8] sm:text-[13px]"
            >
              View All Collections
              <FiArrowRight size={15} />
            </a>
          </div>

       <div className="grid grid-cols-1 gap-3 sm:grid-cols-3 sm:gap-3">
  {collections.map((collection) => (
    <a
      key={collection.title}
      href={collection.href}
      aria-label={collection.title}
      className="group block min-w-0 overflow-hidden rounded-lg"
    >
      <img
        src={collection.image}
        alt={collection.title}
        loading="lazy"
        className="block h-[150px] w-full rounded-lg object-contain transition-transform duration-300 sm:h-[125px] md:h-[140px] lg:h-[155px]"
      />
    </a>
  ))}
</div>
        </div>

        {/* Sell on Pufframa */}
        <div className="relative overflow-hidden border-y border-[#e9dff1] bg-[#f6effb]">
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-[#f8f2fc] via-[#f4ebfb] to-[#eee3f7]" />

          <div className="relative grid grid-cols-1 items-center gap-7 px-4 py-7 sm:px-6 sm:py-8 lg:grid-cols-[1.15fr_1.5fr_auto] lg:gap-8 lg:px-[4%] lg:py-7">

            {/* Seller introduction */}
            <div className="relative z-10 min-w-0">
              <p className="mb-2 text-[10px] font-extrabold uppercase leading-4 tracking-[1.8px] text-[#7027df] sm:text-[11px]">
                For Brands &amp; Businesses
              </p>

              <h2 className="font-serif text-[28px] font-bold leading-tight tracking-[-0.7px] text-[#211b28] sm:text-[31px]">
                Sell on Pufframa
              </h2>

              <p className="mt-3 max-w-[390px] text-[13px] leading-[21px] text-[#514958] sm:text-[14px] sm:leading-[22px]">
                Join a growing marketplace for adult lifestyle, wellness and
                alternative products. Reach new customers and grow your brand
                with Pufframa.
              </p>
            </div>

            {/* Seller benefits */}
            <div className="relative z-10 grid grid-cols-1 gap-5 sm:grid-cols-3 sm:gap-4 lg:gap-6">
              {sellerBenefits.map((benefit) => {
                const Icon = benefit.icon;

                return (
                  <div
                    key={benefit.title}
                    className="flex min-w-0 flex-col items-center text-center"
                  >
                    <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-full bg-white/80 text-[#7027df] shadow-sm">
                      <Icon size={21} strokeWidth={1.8} />
                    </div>

                    <h3 className="text-[13px] font-bold leading-[19px] text-[#302839] sm:text-[13px]">
                      {benefit.title}
                    </h3>

                    <p className="mt-1 max-w-[180px] text-[12px] leading-[18px] text-[#716879]">
                      {benefit.description}
                    </p>
                  </div>
                );
              })}
            </div>

            {/* CTA */}
            <div className="relative z-10 flex items-center justify-start lg:justify-end lg:pr-[65px]">
              <a
                href="/vendor-registration"
                className="inline-flex h-[42px] items-center justify-center gap-2 rounded-md bg-[#6827d9] px-5 text-[13px] font-semibold text-white shadow-sm transition-colors hover:bg-[#5120ad]"
              >
                Start Selling
                <FiArrowRight size={16} />
              </a>
            </div>

            {/* Decorative Pufframa package */}
            <div className="pointer-events-none absolute bottom-0 right-0 hidden h-[105px] w-[115px] items-end justify-center lg:flex">
              <div className="relative mb-2 flex h-[64px] w-[77px] items-center justify-center border border-[#d5b995] bg-[#d8b88d] shadow-md">
                <div className="absolute -top-[10px] left-0 h-[11px] w-full border border-[#c7a67d] bg-[#e7cda9]" />
                <span className="text-[9px] font-black tracking-[-0.5px] text-[#30251b]">
                  PUFFRAMA
                </span>
              </div>

              <div className="absolute right-1 top-1 rotate-[-8deg] text-[#538d35]">
                <FiHeart size={34} />
              </div>
            </div>
          </div>
        </div>

        {/* Why Shop Pufframa */}
        <div className="px-4 py-6 sm:px-6 sm:py-7 lg:px-[4%]">
          <div className="mb-5">
            <SectionHeading>Why Shop Pufframa</SectionHeading>
          </div>

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-5 lg:gap-5">
            {shoppingBenefits.map((benefit) => {
              const Icon = benefit.icon;

              return (
                <div
                  key={benefit.title}
                  className="flex min-w-0 items-center gap-3"
                >
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#f5edfc] text-[#7027df]">
                    <Icon size={20} strokeWidth={1.8} />
                  </div>

                  <div className="min-w-0">
                    <h3 className="text-[13px] font-bold leading-[19px] text-[#302839]">
                      {benefit.title}
                    </h3>

                    <p className="mt-1 text-[12px] leading-[18px] text-[#77717f]">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
}
